import React from 'react';

const TermsConditions = () => {
  return (
    // 1. PAGE BACKGROUND (Cream Theme)
    <div style={{ backgroundColor: '#FFF8E7', minHeight: '100vh', padding: '60px 20px' }}>
      
      {/* 2. THE DOCUMENT CARD (White Paper Effect) */}
      <div className="container" style={{ 
          maxWidth: '900px', 
          backgroundColor: '#ffffff', 
          borderRadius: '15px', 
          boxShadow: '0 10px 30px rgba(0,0,0,0.05)', 
          padding: '40px 40px',
          border: '1px solid #f0e6d2' 
      }}>
        
        {/* HEADER */}
        <div className="text-center mb-5">
          <h1 className="fw-bold" style={{ fontFamily: 'serif', color: '#333', fontSize: '2.5rem' }}>
            Terms & Conditions
          </h1>
          {/* Gold Underline */}
          <div style={{ width: '100px', height: '3px', backgroundColor: '#FFC35B', margin: '15px auto' }}></div>
        </div>
        
        <div className="policy-content" style={{ fontFamily: 'Georgia, serif', color: '#444', lineHeight: '1.8' }}>
          
          <p style={{ fontSize: '1.1rem', marginBottom: '30px', textAlign: 'center', fontStyle: 'italic' }}>
            Welcome to Divine Depot! These Terms & Conditions govern your access to and use of the Divine Depot website and its services.
          </p>

          {/* SECTION 1 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              1. Eligibility
            </h4>
            <p>You must be at least 18 years old and have the legal capacity to enter into contracts to use the Website or Services. By using the Website or Services, you represent and warrant that you meet all of these eligibility requirements.</p>
          </div>

          {/* SECTION 2 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              2. User Accounts
            </h4>
            <p>If you create an account on the Website, you are responsible for maintaining the confidentiality of your account information, including your login credentials, and for all activity that occurs under your Account. You agree to notify Divine Depot immediately of any unauthorized use of your Account.</p>
          </div>

          {/* SECTION 3 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              3. Acceptable Use
            </h4>
            <p>You agree to use the Website and Services only for lawful purposes. You agree not to:</p>
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px' }}>
                <li className="mb-2">Use the website in any way that violates applicable laws.</li>
                <li className="mb-2">Transmit content that is harmful, offensive, or infringing on intellectual property.</li>
                <li className="mb-2">Interfere with or disrupt the Website or Services.</li>
                <li className="mb-2">Attempt to gain unauthorized access to the Website or other user accounts.</li>
            </ul>
          </div>

          {/* SECTION 4 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              4. User Content
            </h4>
            <p>By submitting User Content, you grant Divine Depot a non-exclusive license to use, reproduce, and display such content. You represent that you own all rights to the User Content you submit.</p>
          </div>

          {/* SECTION 5 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              5. Termination
            </h4>
            <p>Divine Depot reserves the right to terminate your access to the Website and Services at any time, for any reason, with or without notice.</p>
          </div>

          {/* SECTION 6 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              6. Disclaimer of Warranties
            </h4>
            <p className="text-muted small">THE WEBSITE AND SERVICES ARE PROVIDED "AS IS" WITHOUT ANY WARRANTY OF ANY KIND. DIVINE DEPOT DOES NOT WARRANT THAT THE WEBSITE WILL BE UNINTERRUPTED OR ERROR-FREE.</p>
          </div>

          {/* SECTION 7 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              7. Limitation of Liability
            </h4>
            <p className="text-muted small">DIVINE DEPOT SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING OUT OF YOUR USE OF THE WEBSITE.</p>
          </div>

          {/* SECTION 8 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              8. Indemnification
            </h4>
            <p>You agree to indemnify and hold harmless Divine Depot from any claims arising out of your use of the Website or violation of these Terms.</p>
          </div>

          {/* SECTION 9 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              9. Governing Law
            </h4>
            <p>These Terms shall be governed by and construed in accordance with the laws of India.</p>
          </div>

          {/* SECTION 10 */}
          <div className="mb-4">
            <h4 className="fw-bold" style={{ color: '#d4a017', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '15px' }}>
              10. Dispute Resolution
            </h4>
            <p>Any dispute shall be resolved by binding arbitration in accordance with the Arbitration and Conciliation Act, 1996. The arbitration shall be conducted in Punjab.</p>
          </div>
          
          <hr style={{ margin: '60px 0', borderTop: '2px dashed #d4a017', opacity: 0.5 }}/>

          {/* RETURN & REFUND SECTION */}
          <div className="text-center mb-5">
            <h2 className="fw-bold" style={{ fontFamily: 'serif', color: '#333' }}>Return & Refund Policy</h2>
            <div style={{ width: '80px', height: '3px', backgroundColor: '#FFC35B', margin: '15px auto' }}></div>
          </div>

          <div className="row g-4">
            <div className="col-md-6">
                 <h5 className="fw-bold mb-3" style={{ color: '#d4a017' }}>1. Return Eligibility</h5>
                 <p>You may return most new, unopened items within 7-10 days of delivery for a full refund. Items must be in original packaging. Used, damaged, or clearance items are not eligible.</p>
            </div>
            <div className="col-md-6">
                 <h5 className="fw-bold mb-3" style={{ color: '#d4a017' }}>2. Return Process</h5>
                 <p>To initiate a return, contact customer support at <br/><strong>+91-6283013500</strong> or <strong>info@divinedepot.in</strong>.</p>
            </div>
            <div className="col-md-6">
                 <h5 className="fw-bold mb-3" style={{ color: '#d4a017' }}>3. Shipping Costs</h5>
                 <p>We cover shipping if the return is due to our error. You cover shipping for other reasons (e.g., changed mind).</p>
            </div>
            <div className="col-md-6">
                 <h5 className="fw-bold mb-3" style={{ color: '#d4a017' }}>4. Refunds</h5>
                 <p>Refunds are issued to the original payment method within 7-10 business days after we receive and verify the return.</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default TermsConditions;